import { computed } from 'vue';
import useClient from '@composables/useClient';

export default async function useCompanySecurity() {
    const { currentLegacyCompany } = useClient();

    const ordersEnabled = computed(() => {
        if (currentLegacyCompany.value && currentLegacyCompany.value.orderSettings) {
            return currentLegacyCompany.value.orderSettings.enabled;
        }

        return false;
    });

    return {
        ordersEnabled,
    };
}
